/* eslint-disable react/jsx-no-bind */
import React from 'react';
import styled from 'styled-components';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import { descryptRijndaelCode } from 'src/shared/AppUtils';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import filee from '../../asset/pdfs/sample-protected.pdf'

const Wrapper = styled.div`
  height: 600px;

  input {
    height: auto;
  }
`;

function PdfReader({ src, password }) {
  const transform = (slot) => {
    return Object.assign({}, slot, {
      Print: () => <></>,
      Download: () => <></>,
      Open: () => <></>,
    });
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: () => <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>,
  });
  const toolbarPluginInstance = toolbarPlugin();
  const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;

  const handleAskPassword = (e) => {
    const decryptedPassword = descryptRijndaelCode(password);
    e.verifyPassword(decryptedPassword);
  };

  return (
    <Wrapper>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <Viewer
          fileUrl={src}
          plugins={[defaultLayoutPluginInstance]}
          transformGetDocumentParams={(options) =>
            Object.assign({}, options, {
              disableRange: true,
              disableStream: true,
            })
          }
          onDocumentAskPassword={handleAskPassword}
        />
      </Worker>
    </Wrapper>
  );
}

export default PdfReader;
